import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuickOrderListItemsUploadedParameters extends TrackEventBaseParameters {}

const trackQuickOrderListItemsUploaded = (
    parameters: TrackQuickOrderListItemsUploadedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "quick_order_list_items_uploaded", ...parameters }, options);
};

export default trackQuickOrderListItemsUploaded;
